import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-20 pb-12 md:pb-0 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 via-background-50 to-background-50"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs md:text-sm font-medium mb-4">
              <i className="ri-sparkling-line"></i>
              <span>海量资源 · 免费下载 · 极速离线</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              51漫画
              <br />
              <span className="text-primary-500">免费漫画下载与全集离线阅读平台</span>
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-heading mb-6">
              随时随地，畅享漫画世界
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              51漫画是国内领先的免费漫画资源聚合平台，汇集了上万部各类漫画作品，涵盖热血、恋爱、奇幻、悬疑、搞笑等多种题材。平台支持免费下载与离线阅读，提供手机客户端安装，让您无需网络也能畅快阅读漫画全集。每日更新最新漫画章节，热门漫画一网打尽，是漫画爱好者必备的阅读利器。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-500">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line"></i>
                立即下载APP
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 font-medium rounded-full text-sm md:text-base hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200/70"
              >
                <i className="ri-book-open-line"></i>
                在线阅读
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20comic%20book%20collage%20with%20dynamic%20manga%20panels%20floating%20in%20space%20featuring%20action%20scenes%20fantasy%20characters%20with%20dramatic%20poses%20speech%20bubbles%20comic%20page%20halftone%20patterns%20warm%20orange%20and%20red%20gradient%20background%20energetic%20atmosphere%20digital%20art%20style%20with%20japanese%20manga%20influence%20modern%20flat%20design%20aesthetic%20editorial%20illustration%20composition%20with%20depth%20and%20movement%20clean%20edges%20professional%20graphic%20design&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="51漫画 - 免费漫画下载与全集离线阅读平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}